export default __webpack_public_path__ + "static/media/miracle.eef8ec8c.png";